import * as ACTION_TYPES from './constants';

import { Setting } from '../../../Api';

import { Toast } from '../../Common';

const Api = Setting.Command;

const reducer = 'SettingCommandReducer';

export default class SettingCommandActions {
    static loading_index = toggle => ({
        type: ACTION_TYPES.SETTING_COMMAND_LOADING_INDEX,
        toggle,
    });

    static loading_show = toggle => ({
        type: ACTION_TYPES.SETTING_COMMAND_LOADING_SHOW,
        toggle,
    });

    static search =
        (search = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: ACTION_TYPES.SETTING_COMMAND_SEARCH, search });
        };

    static requests = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index(true));
            const query = getState()[reducer].get('search');
            const res = await Api.index(query);
            if (res instanceof Error) throw res;
            dispatch(this.index(res));
        } catch (error) {
            dispatch(this.loading_index(false));
            console.error(error);
        } finally {
        }
    };

    static index = (commands = []) => ({
        type: ACTION_TYPES.SETTING_COMMAND_INDEX,
        commands,
    });

    static request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.show(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const body = getState()[reducer].get('command');
            const res = await Api.create(body);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已保存');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static destroy = () => async (dispatch, getState) => {
        try {
            const params = getState()[reducer].getIn(['command', 'id']);
            dispatch(this.loading_show());
            const res = await Api.destroy(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static show = (command = {}) => ({
        type: ACTION_TYPES.SETTING_COMMAND_SHOW,
        command,
    });

    static reset = () => ({
        type: ACTION_TYPES.SETTING_COMMAND_RESET,
    });

    static column = (columns = []) => ({
        type: ACTION_TYPES.SETTING_COMMAND_COLUMN,
        columns,
    });

    static options = () => async (dispatch, getState) => {
        try {
            const res = await Api.options();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_COMMAND_OPTION,
                options: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    static record = query => async (dispatch, getState) => {
        try {
            if (!query) {
                return dispatch({
                    type: ACTION_TYPES.SETTING_COMMAND_RECORD,
                    records: [],
                });
            }

            dispatch(this.loading_show());
            const res = await Api.record(query);
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_COMMAND_RECORD,
                records: res,
            });
        } catch (error) {
            throw error;
        }
    };
}
